import { userConstants } from '../constants/user.constants.js';

let user = localStorage.getItem('user') ?? JSON.parse(localStorage.getItem('user'));
const initialState = user ? { loggedIn: false, user } : {};

export default function authentication(state = initialState, action) {
    switch (action.type) {
        case userConstants.LOGIN_REQUEST:
            return {
                loggedIn: false,
                user: {},
                action
            };
        case userConstants.LOGIN_SUCCESS:
            return {
                loggedIn: true,
                user: action.user,
                action
            };
        case userConstants.LOGIN_FAILURE:
            return {
                loggedIn: false,
                user: {},
                action
            };
        case userConstants.LOGOUT:
            return {
                loggedIn: false,
                user: {},
                action
            };
        default:
            return state
    }
}